import React, { Component } from 'react';
import { withApollo } from 'react-apollo';
import { withNamespaces } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import _get from 'lodash/get';
import Grid from '@material-ui/core/Grid';
import LoadingIndicator from '../../components/LoadingIndicator';
import LocationDetails from '../../components/location/Details';
import combineStyles from '../../utils/combineStyles';
import LayoutStyles from '../../styles/layout';
import ButtonStyles from '../../styles/button';
import TypographyStyles from '../../styles/typography';
import SpacingStyles from '../../styles/helpers/spacing';
import * as Queries from '../../graphQL/queries/locationQueries';
import SinglePointMap from '../../components/Global/Maps/SinglePointMap';
import AssignedContacts from '../../components/location/AssignedContacts';
import { allContacts } from '../../graphQL/queries/contactQueries';
import { AppContext } from '../../AppProvider';
import Toggle from '../../components/Global/Buttons/Toggle';
import * as Mutations from '../../graphQL/mutations/locationMutations';

const styles = theme => ({
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5
  },
  title: {
    marginRight: theme.spacing.unit * 4
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'rgba(12,31,44, 0.04)'
    }
  },
  details: {
    minHeight: 380,
    position: 'relative'
  },
  mapContainer: { width: '100%', minHeight: 368, position: 'relative' }
});

export class LocationDetail extends Component {
  state = {
    contacts: [],
    loading: true,
    assignedContactsLoading: false,
    error: null,
    isOpenedContactFormModal: false,
    contactsList: [],
    location: {}
  };

  async componentDidMount() {
    await this._getLocation('loading');
  }
  _getLocation = async loadingVariable => {
    const {
      client: ApolloClient,
      match: {
        params: { id }
      }
    } = this.props;
    this.setState({ [loadingVariable]: true });
    try {
      const {
        data: {
          location: { byId: location }
        }
      } = await ApolloClient.query({
        query: Queries.byId,
        variables: { id },
        fetchPolicy: 'network-only',
        skip: true
      });
      const contactsList = await this._getContacts();
      this.setState({
        location,
        contactsList
      });
    } catch (error) {
      this.setState({
        error
      });
    } finally {
      this.setState({
        [loadingVariable]: false
      });
    }
  };

  _getContacts = async () => {
    const { client: ApolloClient } = this.props;
    const { currentOrgId: orgId } = this.context.globalProps;
    try {
      const {
        data: {
          contact: { all: contactsList }
        }
      } = await ApolloClient.query({
        query: allContacts,
        variables: { orgId },
        fetchPolicy: 'network-only',
        skip: true
      });
      return contactsList;
    } catch (error) {
      this.setState({
        error
      });
    }
    return false;
  };

  _toggleLocationActive = async status => {
    const { client: ApolloClient } = this.props;
    const {
      location: { id, rowVersion }
    } = this.state;

    const expired = !status ? true : false;
    try {
      await ApolloClient.mutate({
        mutation: Mutations.updateLocationMutation,
        variables: {
          location: { id, rowVersion, expired }
        }
      });
    } catch (error) {
      this.setState({
        error
      });
    }
  };
  render() {
    const { t, classes, history, client: ApolloClient } = this.props;
    const { location, contactsList } = this.state;
    const {
      currentOrgId: orgId,
      orgInfo: { divisionId }
    } = this.context.globalProps;
    const isLocationActive = _get(location, 'active', false);

    return (
      <div>
        <div className={classes.titleWrapper}>
          <h1
            className={classnames(
              classes.headline4,
              classes.noMarginBottom,
              classes.title
            )}
          >
            {`${t('Location')} ${location.name || ''}`}
          </h1>
          <Toggle
            value={isLocationActive}
            onChange={this._toggleLocationActive}
          />
        </div>
        <Grid container spacing={16}>
          <Grid item lg={12}>
            {!this.state.loading && (
              <LocationDetails location={location} history={history} />
            )}
          </Grid>
          <Grid item lg={6}>
            {!this.state.loading && (
              <AssignedContacts
                contactsList={contactsList}
                assignedContacts={location.contactLinks || []}
                ApolloClient={ApolloClient}
                locationId={location.id}
                rowVersion={location.rowVersion}
                primaryContactId={location.primaryContactId}
                orgId={orgId}
                divisionId={divisionId}
                onUpdate={this._getLocation}
                contactsLoading={this.state.assignedContactsLoading}
              />
            )}
          </Grid>
          <Grid item lg={6}>
            {!_get(location, 'address.lat') &&
            !_get(location, 'address.long') ? (
              <LoadingIndicator />
            ) : (
              <SinglePointMap
                mapId={'locationMap'}
                lat={_get(location, 'address.lat')}
                long={_get(location, 'address.long')}
                containerClass={classes.mapContainer}
              />
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}
LocationDetail.contextType = AppContext;
const LocationDetailWithTranslation = withNamespaces()(LocationDetail);
export default withStyles(
  combineStyles(
    LayoutStyles,
    ButtonStyles,
    TypographyStyles,
    SpacingStyles,
    styles
  )
)(withApollo(LocationDetailWithTranslation));
